module.exports = __webpack_public_path__ + "static/mediaFullFlow-61ba340d54c98045a0fc3665d9779e13.mp4";